/* eslint-disable radix */
/* eslint-disable no-undef */
import React from 'react';
import Utils from 'Utils/utils';

const IntlPhoneComponent = props => {
  const { id, phoneNumber, setPhoneNumber } = props;

  const allowOnlyNumbers = event => {
    const { charCode } = event;
    return (
      (charCode >= 48 && charCode <= 57) ||
      charCode === 32 ||
      charCode === 40 ||
      charCode === 41 ||
      charCode === 43 ||
      charCode === 45 ||
      charCode === 46
    );
  };

  const formatInputNumber = (e, type) => {
    const currentValue = e.currentTarget.value;
    setPhoneNumber(parseInt(currentValue));
    if (Utils.intlProps !== undefined) {
      const phoneNew = window.intlTelInputUtils.formatNumber(
        currentValue,
        Utils.intlProps.getSelectedCountryData().iso2,
        window.intlTelInputUtils.numberFormat.NATIONAL,
      );
      setPhoneNumber(phoneNew);
    }
  };

  return (
    <>
      <input
        id={id}
        type="tel"
        placeholder="Phone"
        onChange={e => formatInputNumber(e)}
        onKeyUp={e => formatInputNumber(e)}
        name="phone"
        value={phoneNumber}
        onKeyPress={allowOnlyNumbers}
      />
    </>
  );
};

export { IntlPhoneComponent };
export default IntlPhoneComponent;
